import { modalRoute } from '@/router/helpers/modalRoute'
import { useWallets } from '@/store/wallets'

export const walletRoutes = [
  {
    path: 'wallet',
    children: [
      {
        path: '',
        name: 'Wallets',
        component: () => import('@/components/wallets/list/WalletList.vue'),
        children: [
          modalRoute(
            'add',
            'CreateWallet',
            () => import('@/components/wallets/modals/create/AddWallet.vue'),
          ),
          modalRoute(
            'add/request',
            'CreateWalletRequest',
            () =>
              import('@/components/wallets/modals/create/AddWalletRequest.vue'),
          ),
          modalRoute(
            'add/card',
            'CreateWalletCard',
            () =>
              import('@/components/wallets/modals/create/AddWalletCard.vue'),
            {
              meta: {
                permissions: ['cardWalletCreate'],
              },
            },
          ),
          modalRoute(
            'transfer/:walletUuid',
            'TransferFromWalletList',
            () => import('@/components/wallets/modals/transfer/Transfer.vue'),
          ),
          modalRoute(
            'create-beneficiary/:walletUuid',
            'CreateBeneficiary',
            () => import('@/components/beneficiaries/modals/Add.vue'),
            {
              props: true,
            },
          ),
          modalRoute(
            'order-card/:walletUuid?',
            'OrderCardFromWallets',
            () =>
              import('@/components/wallets/modals/order-card/OrderCard.vue'),
          ),
          modalRoute(
            'exchange/:walletUuid?',
            'Exchange',
            () => import('@/components/wallets/modals/Exchange.vue'),
            {
              props: true,
            },
          ),
          modalRoute(
            'top-up',
            'TopUpWallet',
            () =>
              import(
                '@/components/wallets/modals/top-up/parts/TopUpWallet.vue'
              ),
          ),
          modalRoute(
            'top-up/:walletUuid',
            'TopUpList',
            () =>
              import('@/components/wallets/modals/top-up/parts/TopUpList.vue'),
          ),
          modalRoute(
            'top-up/:walletUuid/by-card',
            'TopUpByCard',
            () =>
              import(
                '@/components/wallets/modals/top-up/parts/forms/TopUpFromCard.vue'
              ),
          ),
          modalRoute(
            'top-up/:walletUuid/by-open-banking',
            'TopUpByOpenBanking',
            () =>
              import(
                '@/components/wallets/modals/top-up/parts/forms/TopUpFromOpenBanking.vue'
              ),
          ),
          modalRoute(
            'open-banking/return/:hash',
            'OpenBankingReturn',
            () => import('@/components/wallets/modals/OpenBankingStatus.vue'),
          ),
          modalRoute(
            'open-banking/expiry/:hash',
            'OpenBankingExpiry',
            () => import('@/components/wallets/modals/OpenBankingStatus.vue'),
          ),
          modalRoute(
            'open-banking/cancel/:hash',
            'OpenBankingCancel',
            () => import('@/components/wallets/modals/OpenBankingStatus.vue'),
          ),
          modalRoute(
            'top-up/:walletUuid/by-apple-pay',
            'TopUpByApplePay',
            () =>
              import(
                '@/components/wallets/modals/top-up/parts/forms/TopUpFromApplePay.vue'
              ),
          ),
          modalRoute(
            'top-up/:walletUuid/by-wallet',
            'TopUpByWallet',
            () =>
              import(
                '@/components/wallets/modals/top-up/parts/forms/TopUpFromWallet.vue'
              ),
          ),
          modalRoute(
            'top-up/:walletUuid/bank-transfer',
            'TopUpByBankTransfer',
            () =>
              import('@/components/wallets/modals/details/WalletDetails.vue'),
          ),
        ],
      },
      {
        path: ':walletUuid',
        name: 'Wallet',
        component: () => import('@/components/wallets/view/WalletItem.vue'),
        meta: {
          validateRoute: (to) =>
            !!useWallets().getWalletByUuid(to.params.walletUuid),
          fallbackRoute: { name: 'Wallets' },
        },
        children: [
          modalRoute(
            'send/to-card',
            'Wallet:SendToCard',
            () =>
              import(
                '@/components/wallets/modals/transfer-to-card/SendToCard.vue'
              ),
            {
              meta: {
                permissions: ['transferToCardCreate'],
              },
            },
          ),
          modalRoute(
            'bulk-drafts',
            'BulkDrafts',
            () => import('@/components/bulk-drafts/BulkDraftsModal.vue'),
          ),
          modalRoute(
            'transfer/repeat/:paymentId',
            'Wallet:TransferRepeat',
            () => import('@/components/wallets/modals/transfer/Transfer.vue'),
          ),
          modalRoute(
            'top-up',
            'TopUpFromWallet',
            () =>
              import('@/components/wallets/modals/top-up/parts/TopUpList.vue'),
          ),
          modalRoute(
            'top-up/by-card',
            'TopUpByCardFromWallet',
            () =>
              import(
                '@/components/wallets/modals/top-up/parts/forms/TopUpFromCard.vue'
              ),
          ),
          modalRoute(
            'top-up/by-open-banking',
            'TopUpByOpenBankingFromWallet',
            () =>
              import(
                '@/components/wallets/modals/top-up/parts/forms/TopUpFromOpenBanking.vue'
              ),
          ),
          modalRoute(
            'top-up/by-apple-pay',
            'TopUpByApplePayFromWallet',
            () =>
              import(
                '@/components/wallets/modals/top-up/parts/forms/TopUpFromApplePay.vue'
              ),
          ),
          modalRoute(
            'top-up/by-wallet',
            'TopUpByWalletFromWallet',
            () =>
              import(
                '@/components/wallets/modals/top-up/parts/forms/TopUpFromWallet.vue'
              ),
          ),
          modalRoute(
            'top-up/bank-transfer',
            'TopUpByBankTransferFromWallet',
            () =>
              import('@/components/wallets/modals/details/WalletDetails.vue'),
          ),
          modalRoute(
            'open-banking/return/:hash',
            'OpenBankingReturnFromWallet',
            () => import('@/components/wallets/modals/OpenBankingStatus.vue'),
          ),
          modalRoute(
            'open-banking/expiry/:hash',
            'OpenBankingExpiryFromWallet',
            () => import('@/components/wallets/modals/OpenBankingStatus.vue'),
          ),
          modalRoute(
            'open-banking/cancel/:hash',
            'OpenBankingCancelFromWallet',
            () => import('@/components/wallets/modals/OpenBankingStatus.vue'),
          ),
          modalRoute(
            'exchange',
            'ExchangeFromWallet',
            () => import('@/components/wallets/modals/Exchange.vue'),
          ),
          modalRoute(
            'transfer',
            'TransferFromWallet',
            () => import('@/components/wallets/modals/transfer/Transfer.vue'),
          ),
          modalRoute(
            'add-beneficiary',
            'AddBeneficiaryFromWallet',
            () => import('@/components/beneficiaries/modals/Add.vue'),
            {
              meta: {
                permissions: ['beneficiaryCreate'],
              },
            },
          ),
          modalRoute(
            'details',
            'WalletDetails',
            () =>
              import('@/components/wallets/modals/details/WalletDetails.vue'),
          ),
          modalRoute(
            'crypto/sell',
            'Wallet:SellCrypto',
            () => import('@/components/crypto/modals/sell/SellModal.vue'),
            {
              meta: {
                permissions: ['cryptoSell'],
              },
            },
          ),
          modalRoute(
            'edit',
            'WalletEdit',
            () => import('@/components/wallets/modals/WalletEdit.vue'),
            {
              meta: {
                permissions: ['walletEdit'],
              },
            },
          ),
          modalRoute(
            'close',
            'WalletClose',
            () => import('@/components/wallets/modals/WalletClose.vue'),
            {
              meta: {
                permissions: ['walletClose'],
              },
            },
          ),
          modalRoute(
            'p/drafts',
            'WalletDrafts',
            () =>
              import(
                '@/components/wallets/view/parts/history/modals/drafts/DraftsModal.vue'
              ),
            {
              meta: {
                permissions: ['paymentSign', 'paymentDelete'],
                permissionStrategy: 'some',
              },
            },
          ),
          modalRoute(
            'p/:paymentId',
            'Wallet:PaymentDetails',
            () =>
              import(
                '@/components/wallets/view/parts/history/modals/details/HistoryItemDetails.vue'
              ),
          ),
          modalRoute(
            'p/:paymentId/repeat',
            'Wallet:PaymentDetails:TransferRepeat',
            () => import('@/components/wallets/modals/transfer/Transfer.vue'),
          ),
          modalRoute(
            'p/:paymentId/delete',
            'Wallet:PaymentDetails:DraftDelete',
            () =>
              import(
                '@/components/wallets/view/parts/history/modals/drafts/DraftDeleteModal.vue'
              ),
          ),
          modalRoute(
            'c/:cardId',
            'CardDetails',
            () =>
              import(
                '@/components/wallets/view/parts/cards/modals/details/CardDetails.vue'
              ),
          ),
          modalRoute(
            'c/:cardId/unfreeze',
            'CardUnfreeze',
            () =>
              import(
                '@/components/wallets/view/parts/cards/modals/unfreeze/CardUnfreeze.vue'
              ),
          ),
          modalRoute(
            'c/:cardId/pin',
            'ChangeCardPin',
            () =>
              import(
                '@/components/wallets/view/parts/cards/modals/pin/ChangeCardPin.vue'
              ),
          ),
          modalRoute(
            'c/:cardId/phone',
            'ChangeCardPhone',
            () =>
              import(
                '@/components/wallets/view/parts/cards/modals/phone/ChangeCardPhone.vue'
              ),
          ),
          modalRoute(
            'c/:cardId/password',
            'ChangeCardPassword',
            () =>
              import(
                '@/components/wallets/view/parts/cards/modals/password/ChangeCardPassword.vue'
              ),
          ),
          modalRoute(
            'c/:cardId/notifications',
            'ChangeCardNotifications',
            () =>
              import(
                '@/components/wallets/view/parts/cards/modals/notifications/ChangeCardNotifications.vue'
              ),
          ),
          modalRoute(
            'c/:cardId/limits',
            'ChangeCardLimits',
            () =>
              import(
                '@/components/wallets/view/parts/cards/modals/limits/ChangeCardLimits.vue'
              ),
          ),
          modalRoute(
            'c/:cardId/limits/online-payments',
            'CardLimitsOnlinePayments',
            () =>
              import(
                '@/components/wallets/view/parts/cards/modals/limits/ChangeCardLimit.vue'
              ),
            {
              props: {
                modal: {
                  group: ['internetPurchase'],
                },
              },
            },
          ),
          modalRoute(
            'c/:cardId/limits/atm',
            'CardLimitsATM',
            () =>
              import(
                '@/components/wallets/view/parts/cards/modals/limits/ChangeCardLimit.vue'
              ),
            {
              props: {
                modal: {
                  group: ['withdrawal'],
                },
              },
            },
          ),
          modalRoute(
            'c/:cardId/limits/purchase',
            'CardLimitsPurchase',
            () =>
              import(
                '@/components/wallets/view/parts/cards/modals/limits/ChangeCardLimit.vue'
              ),
            {
              props: {
                modal: {
                  group: ['contactlessPurchase', 'purchase'],
                },
              },
            },
          ),
          modalRoute(
            'c/:cardId/close',
            'CardClose',
            () =>
              import(
                '@/components/wallets/view/parts/cards/modals/close/CardClose.vue'
              ),
          ),
          modalRoute(
            'c/:cardId/delivery',
            'CardDeliveryStatus',
            () =>
              import(
                '@/components/wallets/view/parts/cards/modals/delivery/DeliveryStatus.vue'
              ),
          ),
          modalRoute(
            'c/order',
            'OrderCard',
            () =>
              import('@/components/wallets/modals/order-card/OrderCard.vue'),
          ),
        ],
      },
    ],
  },
]
